// Utils
import getPointerDirection from './getPointerDirection';
import getContentPosition from './getContentPosition';
import getIsTargetOverflowing from './getIsTargetOverflowing';
import getPointerAngle from './getPointerAngle';

export default (args) => {
    const { targetPoint, targetRect, pointerRect, layerRect, preferredDirection, margin = 20 } = args;

    const isTargetOverflowing = getIsTargetOverflowing({ targetRect, layerRect });

    const pointerDirection = getPointerDirection({
        targetPoint,
        targetRect,
        pointerRect,
        layerRect,
        preferredDirection,
        margin,
    });

    const contentPosition = getContentPosition({
        targetPoint,
        targetRect,
        pointerRect,
        layerRect,
        margin,
        pointerDirection,
    });

    const arrowRotation = getPointerAngle({
        targetPoint,
        targetRect,
        pointerRect,
        contentPosition,
    });

    return {
        contentPosition,
        arrowRotation,
        isTargetOverflowing,
    };
};
